import { Box, Button, Typography } from '@material-ui/core';
import { UserIcon } from 'components/Icons';
import SicrediLogo from 'components/SicrediLogo/SicrediLogo';
// import { AssociadoRoutePath, MainRoutePath } from 'library/Routes';
import { AssociadoRoutePath } from 'library/Routes';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { history } from 'store/Store';
import useStyle from './style';

interface Props {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  readOnly?: boolean;
  maintenance?: boolean;
}

export default function ({ children, className, style, readOnly, maintenance }: Props) {
  const { t } = useTranslation();
  const classes = useStyle();
  const triggerLogin = useRef<HTMLButtonElement>(null);

  // const goHome = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   e.preventDefault();
  //   history.push(MainRoutePath);
  // };

  return (
    <article
      className={[classes.root, className].join(' ').trim()}
      style={style}
    >
      <header className={classes.header}>
        {/* <a href={MainRoutePath} onClick={goHome} className={classes.logoLink}>
          <SicrediLogo />
        </a> */}
        <Typography className={classes.logoLink}>
          <SicrediLogo />
        </Typography>
        <div className={classes.slogan}>
          Assembleia Digital de Fundos de Investimentos
        </div>
        <div style={{flex: 1}}></div>
        {!readOnly && !maintenance && (
          <Button
            ref={triggerLogin}
            variant="text"
            endIcon={<UserIcon />}
            className={classes.loginButton}
            onClick={() => history.push(AssociadoRoutePath)}
          >
            {t('LoginAssociado.botao')}
          </Button>
        )}
      </header>
      <Box component="div" className={classes.container}>
        {children}
      </Box>
    </article>
  );
}
